import React from "react";
import CrrButton from "../../../../components/UI/CrrButton/CrrButton";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import PartyPopperIcon from "../../../../assets/images/party-popper.svg";
import "./Success.styles.scss";
import text from "../../../../helpers/text.js";
import { getLocalStorage, setLocalStorage } from "../../../../helpers/utils.js";

const Success = () => {
  const history = useHistory();

  const GotoDashboard = () => {
    const userData = getLocalStorage("USER_DETAILS");
    userData.pre_assessment_status = "Completed"; // set completed status to localstorage on completion
    setLocalStorage("USER_DETAILS", userData);
    history.push("/admin-dashboard");
  };

  return (
    <div>
      <div className="success-header">
        <img alt="party-popper" src={PartyPopperIcon} />
        {text.PRE_ASSMNT_SUCCESS_TITLE}
      </div>
      <div className="success-text">{text.PRE_ASSMNT_SUCCESS_MSG}</div>
      <CrrButton className="pre-assessment-btn" onClick={GotoDashboard}>
        {text.GO_TO_DASHBOARD}
      </CrrButton>
    </div>
  );
};

export default Success;
